import { Ref, forwardRef } from "react"
import { FormikProps } from "formik"
import { Formik } from "../../../../../../shared/components/forms/SchemaFormik"
import * as yup from "yup"
import { CreateUpdateTemplate, CreateUpdateTemplateFormValues } from "../supplierPosSettingsTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { CreateUpdateTemplateFormContent } from "./CreateUpdateTemplateFormContent"
import { StandardFormikErrorScrollWrapper } from "../../../../../../shared/components/forms/StandardFormikErrorScrollWrapper"

type CreateUpdateTemplateFormProps = Readonly<{
    initialValues: CreateUpdateTemplateFormValues
    onSubmit: (formData: CreateUpdateTemplate) => void
}>
type FormikRef = Ref<FormikProps<CreateUpdateTemplateFormValues>>

export const CreateUpdateTemplateForm = forwardRef(
    ({ initialValues, onSubmit }: CreateUpdateTemplateFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
            languageCode: yup.string().required(l10n.getString("required-field")),
            layout: yup.object().shape({
                theme: yup.object().shape({ id: yup.number().required(l10n.getString("required-field")) }),
            }),
            content: yup.object().shape({
                centerContent: yup.object().shape({
                    title: yup.object().shape({ label: yup.string().required(l10n.getString("required-field")) }),
                    subtitle: yup.object().shape({ label: yup.string().required(l10n.getString("required-field")) }),
                    purchaseButton: yup
                        .object()
                        .shape({ label: yup.string().required(l10n.getString("required-field")) }),
                }),
                merchantLogo: yup.object().shape({ uid: yup.string().required(l10n.getString("required-field")) }),
            }),
        })

        function handleSubmit(values: CreateUpdateTemplateFormValues) {
            const { layout, content, ...templateValues } = values

            const modifyData = {
                ...templateValues,
                layout: {
                    theme: {
                        id: layout.theme.id ?? 0,
                    },
                },
                content: {
                    ...content,
                    merchantLogo: {
                        uid: content.merchantLogo?.uid ?? "",
                    },
                },
            }
            onSubmit(modifyData)
        }

        return (
            <>
                <Formik<CreateUpdateTemplateFormValues>
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={ref}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    <StandardFormikErrorScrollWrapper<CreateUpdateTemplateFormValues>
                        children={<CreateUpdateTemplateFormContent />}
                    />
                </Formik>
            </>
        )
    },
)
